import { Routes, RouterModule } from '@angular/router';

import { VisualizarEditaisCfcComponent } from './visualizar-editais-cfc/visualizar-editais-cfc.component';
import { CadastroCfcFormComponent } from './cadastro-cfc-form/cadastro-cfc-form.component';
import { GerarRequerimentoCfcComponent } from './gerar-requerimento-cfc/gerar-requerimento-cfc.component';
import { GerenciarCfcComponent } from './gerenciar-cfc/gerenciar-cfc.component';
import { AnalisarCredenciamentoCfcComponent } from './analisar-credenciamento-cfc/analisar-credenciamento-cfc.component';
import { VisualizarHistoricoAnalisesCfcComponent } from './visualizar-historico-cfc/visualizar-historico-cfc.component';
import { VisualizarCfcComponent } from './visualizar-cfc/visualizar-cfc.component';

import { AuthGuard } from '../shared/authentication/auth-guard';
import { GerenciarTermoAditivoCfcComponent } from './gerenciar-termo-aditivo-cfc/gerenciar-termo-aditivo-cfc.component';
import { CadastrarTermoAditivoCfcComponent } from './cadastrar-termo-aditivo-cfc/cadastrar-termo-aditivo-cfc.component';
import { VisualizarTermoAditivoGeradoComponent } from '../candidato/visualizar-termo-aditivo-gerado/visualizar-termo-aditivo-gerado.component';
import { VisualizarTermoAditivoCfcComponent } from './visualizar-termo-aditivo-cfc/visualizar-termo-aditivo-cfc.component';
import { AdminLayoutComponent } from '../_admin-layout/admin-layout.component';

const cfcRoutes: Routes = [
    { path: '', component: AdminLayoutComponent,
            children: [
                { path: 'visualizar-editais-cfc', component: VisualizarEditaisCfcComponent },
                { path: 'cadastro-cfc-form', component: CadastroCfcFormComponent },
                { path: 'gerar-requerimento-cfc', component: GerarRequerimentoCfcComponent },
                { path: 'gerenciar-cfc', component: GerenciarCfcComponent, canActivate: [ AuthGuard ] },
                { path: 'analisar-credenciamento-cfc/:idCfcUnidade', component: AnalisarCredenciamentoCfcComponent, canActivate: [ AuthGuard ] },
                { path: 'visualizar-historico-cfc/:idCfcUnidade', component: VisualizarHistoricoAnalisesCfcComponent, canActivate: [ AuthGuard ] },
                { path: 'visualizar-cfc/:idCfc', component: VisualizarCfcComponent, canActivate: [ AuthGuard ] },
                { path: 'gerenciar-termo-aditivo-cfc/:idCfcUnidade', component: GerenciarTermoAditivoCfcComponent, canActivate: [ AuthGuard ] },
                { path: 'cadastrar-termo-aditivo-cfc/:idCfcUnidade', component: CadastrarTermoAditivoCfcComponent, canActivate: [ AuthGuard ] },
                { path: 'editar-termo-aditivo-cfc/:idCfcUnidade/:idCfcTermoAditivo', component: CadastrarTermoAditivoCfcComponent, canActivate: [ AuthGuard ] },
                { path: 'visualizar-termo-aditivo-cfc/:idCfcTermoAditivo', component: VisualizarTermoAditivoCfcComponent, canActivate: [ AuthGuard ] },
            ]
        }

];

export const CfcRouting = RouterModule.forChild(cfcRoutes);



// WEBPACK FOOTER //
// ./src/app/components/cfc/cfc.routing.ts